import React from "react";
import { Container } from "react-bootstrap";

const PitchIS = () => {
  return (
    <>
      <section className="pt-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">
            Income Statement
          </p>
          {/* first table */}
          <div className="scroll-x">

          
          <table className="custom-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>Year 01</th>
                <th>Year 02</th>
                <th>Year 03</th>
                <th>Year 04</th>
                <th>Year 05</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Sales Revenue</td>
                <td> $7,660,800,000</td>
                <td> $42,681,600,000</td>
                <td> $99,809,280,000</td>
                <td> $162,846,720,000</td>
                <td> $231,575,040,000</td>
              </tr>
              <tr className="active">
                <td>
                  <div className="row-badge-wrapper">
                    <div className="row-badge">26%</div>
                  </div>
                  <span className="badge-cell">COGS</span>
                </td>
                <td> $1,991,808,000</td>
                <td> $11,097,216,000</td>
                <td> $25,950,412,800</td>
                <td> $42,340,147,200</td>
                <td> $60,209,510,400</td>
              </tr>
              <tr>
                <td>Gross Profit</td>
                <td> $5,668,992,000</td>
                <td> $31,584,384,000</td>
                <td> $73,858,867,200</td>
                <td> $120,506,572,800</td>
                <td> $171,365,529,600</td>
              </tr>
              <tr className="active">
                <td>GP Margin</td>
                <td>74%</td>
                <td>74%</td>
                <td>74%</td>
                <td>74%</td>
                <td>74%</td>
              </tr>
            </tbody>
          </table>
          </div>
          {/* second table */}
          <div className="py-5 scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Operating Expenses:</th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Operating Exp</td>
                   	  	  	  	  
                  <td> $ 2,395,631,910 </td>
                  <td> $ 11,951,403,750</td>
                  <td> $ 25,951,712,400</td>
                  <td> $ 39,085,333,200</td>
                  <td> $ 39,085,333,200</td>
                </tr>
                <tr>
                  <td>Selling Exp</td>
                   	  	  	  	  
                  <td> $ 153,216,000</td>
                  <td> $ 853,632,000</td>
                  <td> $ 1,996,185,600</td>
                  <td> $ 3,256,934,400</td>
                  <td> $ 3,256,934,400</td>
                </tr>
                <tr>
                  <td>Admin Exp</td>
                   	  	  	  	  
                  <td> $ 114,948,750</td>
                  <td> $ 640,428,750</td>
                  <td> $ 1,497,618,000</td>
                  <td> $ 2,443,482,000</td>
                  <td> $ 2,443,482,000</td>
                </tr>
                <tr>
                  <td>Other Opex</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr className="active">
                  <td>Operating Exp</td>
                  <td>$ 2,663,796,660</td>
                  <td>$13,445,464,500</td>
                  <td>$29,445,516,000</td>
                  <td>$ 44,785,749,600</td>
                  <td>$ 44,785,749,600</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Third table */}
          <div className="pb-5 scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>EBITDA</th>
                  <th> $3,005,195,340</th>
                  <th> $18,138,919,500</th>
                  <th> $44,413,351,200</th>
                  <th> $75,720,823,200</th>
                  <th> $126,579,780,000</th>
                </tr>
              </thead>
              <tbody>
                <tr className="active">
                  <td>
                    <div className="row-badge-wrapper">
                      <div className="row-badge">6.5%</div>
                    </div>
                    <span className="badge-cell">Interest Incurred</span>
                  </td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td>Dividends</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td>Depreciation & A</td>
                  <td> $2,520,000</td>
                  <td> $9,000,000</td>
                  <td> $17,640,000</td>
                  <td> $26,280,000</td>
                  <td> $36,360,000</td>
                </tr>

                <tr className="lead-row">
                  <td>EBT</td>
                  <td> $3,002,675,340</td>
                  <td> $18,129,919,500</td>
                  <td> $44,395,711,200</td>
                  <td> $75,694,543,200</td>
                  <td> $126,543,420,000</td>
                </tr>
                <tr className="active">
                  <td>
                    <div className="row-badge-wrapper">
                      <div className="row-badge">6.5%</div>
                    </div>
                    <span className="badge-cell">Tax</span>
                  </td>
                  <td> $450,401,301</td>
                  <td> $2,719,487,925</td>
                  <td> $6,659,356,680</td>
                  <td> $11,354,181,480</td>
                  <td> $18,981,513,000</td>
                </tr>
                <tr>
                  <td className="lead-cell">Income After Tax</td>
                  <td> $2,552,274,039</td>
                  <td> $15,410,431,575</td>
                  <td> $37,736,354,520</td>
                  <td> $64,340,361,720</td>
                  <td> $107,561,907,000</td>
                </tr>
                <tr className="active">
                  <td>
                    <div className="row-badge-wrapper">
                      <div className="row-badge">0%</div>
                    </div>
                    <span className="badge-cell">Royalties</span>
                  </td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td className="lead-cell">Net Profit</td>
                  <td> $2,552,274,039</td>
                  <td> $15,410,431,575</td>
                  <td> $37,736,354,520</td>
                  <td> $64,340,361,720</td>
                  <td> $107,561,907,000</td>
                </tr>
                <tr className="lead-row">
                  <td>Net Profit / Sales</td>
                  <td>33%</td>
                  <td>36%</td>
                  <td>38%</td>
                  <td>40%</td>
                  <td>46%</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Fourth table */}
          <div className="pb-5 scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Year 01</th>
                  <th>Year 02</th>
                  <th>Year 03</th>
                  <th>Year 04</th>
                  <th>Year 05</th>
                </tr>
              </thead>
              <tbody>
                <tr className="active lead-row">
                  <td>ROI</td>
                  <td>49%</td>
                  <td>91%</td>
                  <td>105%</td>
                  <td>113%</td>
                  <td>130%</td>
                </tr>
                <tr>
                  <td>Note:</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colSpan={6}>
                    User just need to input in GREY cells and the rest of the
                    Financials and Pictorials would change on AUTO
                  </td>
                </tr>
                {/* 
                <tr className="lead-row">
                  <td>EBT</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                </tr>
                <tr className="active">
                  <td>Tax</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                </tr>
                <tr>
                  <td className="lead-cell">Income After Tax</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                </tr>
                <tr className="active">
                  <td>Royalties</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
                <tr>
                  <td className="lead-cell">Net Profit</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                  <td>$7,350,000,000</td>
                </tr>
                <tr className="lead-row">
                  <td>Net Profit / Sales</td>
                  <td>33%</td>
                  <td>33%</td>
                  <td>33%</td>
                  <td>33%</td>
                  <td>33%</td>
                </tr> */}
              </tbody>
            </table>
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start  px-3 mt-4 mb-2">
            Break-Even Analysis
          </p>
          {/* First Table */}
          <div className="pb-3 scroll-x">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Year 01</th>
                  <th>Year 02</th>
                  <th>Year 03</th>
                  <th>Year 04</th>
                  <th>Year 05</th>
                </tr>
              </thead>
              <tbody>
                <tr className="active lead-row">
                  <td>Break-Even Rev</td>
                  <td> $3,652,488,575</td>
                  <td> $18,181,708,784</td>
                  <td> $39,815,075,676</td>
                  <td> $60,556,796,757</td>
                  <td> $60,570,418,378</td>
                </tr>
              </tbody>
            </table>
          </div>
          {/* Second Table */}
          <div className="scroll-x table-white pb-3 mt-4">
            <table className="custom-table table-white plain-table">
              <tbody>
                <tr className="active lead-row">
                  <td colSpan={6} className="full-cell">
                    Break Even Verification (based on COGS):
                  </td>
                </tr>
                <tr>
                  <td>OPEX</td>
                  <td> $2,666,316,660</td>
                  <td> $13,454,464,500</td>
                  <td> $29,463,156,000</td>
                  <td> $44,812,029,600</td>
                  <td> $44,822,109,600</td>
                </tr>
                <tr>
                  <td>COGS</td>
                  <td>27%</td>
                  <td>26%</td>
                  <td>26%</td>
                  <td>26%</td>
                  <td>26%</td>
                </tr>
                <tr className="lead-row light-row">
                  <td>Break Even Sales </td>
                  <td> $3,652,488,575</td>
                  <td> $18,181,708,784</td>
                  <td> $39,815,075,676</td>
                  <td> $60,556,796,757</td>
                  <td> $60,570,418,378</td>
                </tr>
                <tr>
                  <td colSpan={6} className="border-bottom "></td>
                </tr>
                <tr>
                  <td>Sales</td>
                  <td> $3,652,488,575</td>
                  <td> $18,181,708,784</td>
                  <td> $39,815,075,676</td>
                  <td> $60,556,796,757</td>
                  <td> $60,570,418,378</td>
                </tr>
                <tr>
                  <td>COGS</td>
                  <td> $986,171,915</td>
                  <td> $4,727,244,284</td>
                  <td> $10,351,919,676</td>
                  <td> $15,744,767,157</td>
                  <td> $15,748,308,778</td>
                </tr>
                <tr>
                  <td>Margin</td>
                  <td> $2,666,316,660</td>
                  <td> $13,454,464,500</td>
                  <td> $29,463,156,000</td>
                  <td> $44,812,029,600</td>
                  <td> $44,822,109,600</td>
                </tr>
                <tr className="lead-row light-row">
                  <td>No Profit & No Lo</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                  <td>$</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchIS;
